<template>
  <div>
    <el-dialog
      width="1380px"
      :title="popupTitle"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-tabs :list="this.$constant.tabListZhiZao()" :activeVal.sync="tabActive" />
        <div v-show="tabActive === '0'" class="popup-scroll" :style="{ 'max-height': maxHeight }">
          <TableData5
            v-if="isBom"
            :disabled="disabled"
            :list.sync="selfData.tableBomData"
            :mainData="isOpenLingJian ? selfData.table_data_2[0] : selfData.table_data_1[0]"
          />
          <TableData1
            v-if="!isBom"
            :list.sync="selfData.table_data_1"
            :isChoose="!isBom"
            :disabled="disabled"
            @chooseShangPin="chooseShangPin"
            @doShangPin="doShangPin"
            @fieldUpdate="fieldUpdate"
            @calcComplete="onRawMaterialCalcComplete"
            @rawPriceChange="onRawPriceChange"
          />
          <TableData2
            v-if="!isBom"
            :disabled="disabled"
            :list.sync="selfData.table_data_2"
            :mainData.sync="selfData.table_data_1[0]"
            @fieldUpdate="fieldUpdate"
            @delete="deleteLingJian"
            @partPriceChange="onPartPriceChange"
          />
          <TableData3
            :disabled="disabled"
            :list.sync="selfData.table_data_3"
            :mainData="isOpenLingJian ? selfData.table_data_2[0] : selfData.table_data_1[0]"
            :mainUnit="selfData.unit"
            @chooseMuBan="chooseMuBan"
            @doShangPin="doGongYiShangPin"
          />
          <TableData4
            :disabled="disabled"
            :list.sync="selfData.table_data_4"
            :mainData="isOpenLingJian ? selfData.table_data_2[0] : selfData.table_data_1[0]"
            :mainUnit="selfData.unit"
          />
        </div>
        <TableData0
          v-show="tabActive === '1'"
          :disabled="disabled"
          :data.sync="selfData"
          @fieldUpdate="fieldUpdate"
        />
      </div>
      <div slot="footer">
        <div v-if="!disabled">
          <el-button size="mini" @click="popupCancel">取消</el-button>
          <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 弹窗-选择商品 -->
    <b-popup-choose-shang-pin
      v-if="isShowPopupChooseShangPin"
      :show.sync="isShowPopupChooseShangPin"
      :bind_id="selfData.table_data_1[0].bind_id"
      @success="chooseShangPinSuccess"
    />
    <!-- 弹窗-增改商品 -->
    <PopupDoShangPin
      v-if="isShowPopupDoShangPin"
      :show.sync="isShowPopupDoShangPin"
      :detailType="lei_mu_lei_xing"
      :muBanId="muBanId"
      detailId=""
      @success="doShangPinSuccess"
    />
    <!-- 弹窗-选择模板 -->
    <b-popup-choose-gong-yi
      v-if="isShowPopupChooseMuBan"
      :show.sync="isShowPopupChooseMuBan"
      :bind_id="selfData.table_data_3[activeTableData3Index].bind_id"
      @success="chooseMubanSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    TableData1: () => import('./table-data-1'),
    TableData2: () => import('./table-data-2'),
    TableData3: () => import('./table-data-3'),
    TableData4: () => import('./table-data-4'),
    TableData5: () => import('./table-data-5'),
    TableData0: () => import('./table-data-0'),
    PopupDoShangPin: () => import('@/views/goods/system/shang-pin/common/popup-do-shang-pin')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        tableBomData: []
      },
      tabActive: '0',
      lei_mu_lei_xing: '原料',
      muBanId: '',
      isShowPopupChooseShangPin: false, // 选择商品
      isShowPopupDoShangPin: false, // 增改商品
      isShowPopupChooseMuBan: false, // 选择模板
      activeTableData3Index: null,
      isCascadingPrice: false
    }
  },
  computed: {
    popupTitle() {
      let result = `商品成本核算-${this.selfData.name}`
      if (this.selfData.tableBomData.length) {
        result = `${result}(bom)`
      }
      return result
    },
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 320}px`
      return result
    },
    isBom() {
      return !!this.selfData.tableBomData.length
    },
    // 是否启用零件
    isOpenLingJian() {
      let result = !!this.selfData.table_data_2.length
      return result
    },
    // 手动校验模式：任一零件规格含闭合括号，自动互算不准确，禁止原料↔零件相互估算
    isManualVerify() {
      return this.isOpenLingJian && this.selfData.table_data_2.some((row) => this.$tool.hasBracket(row.spec))
    },
    goodsAmount() {
      let data = this.$util.deepCopy(this.selfData)
      let list = []
      let result = 0
      if (data.table_data_2.length) {
        list = ['table_data_2', 'table_data_3', 'table_data_4']
      } else {
        list = ['table_data_1', 'table_data_3', 'table_data_4']
      }
      list.forEach((itemSt) => {
        data[itemSt].forEach((itemNd) => {
          result = this.$XEUtils.add(result, itemNd.goods_amount)
        })
      })
      return this.$util.getPoint(result, 'up', 4)
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    goodsAmount(val) {
      let result = this.$XEUtils.divide(val, this.selfData.counts)
      this.selfData.goods_price = this.$util.getPoint(result, 'up', 4)
    },
    isBom: {
      handler(val) {
        if(val && this.selfData.table_data_2.length) {
          this.selfData.table_data_2 = []
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfData = this.$util.deepCopy(this.data)
    this.selfData.has_bom = !!this.selfData.tableBomData.length
  },
  methods: {
    // 选择商品
    chooseShangPin() {
      this.isShowPopupChooseShangPin = true
    },
    // 项-选择商品成功
    chooseShangPinSuccess(chooseRow) {
      let newRow = this.$util.deepCopy(this.selfData.table_data_1[0])
      let {
        wu_liao_type,
        id,
        shang_pin_ming_cheng,
        gui_ge_shi_li,
        dan_wei,
        zong_shu_liang,
        dan_jia,
        zong_jin_e,
        lei_mu_data
      } = chooseRow
      let list = ['table_data_2', 'table_data_3', 'table_data_4']
      // newRow更新字段
      newRow.wu_liao_type = wu_liao_type
      newRow.bind_id = id
      newRow.list_fenl_lei_ids = lei_mu_data.category_list.map((itemCatrgory) => itemCatrgory.id)
      newRow.list_fenl_lei_str = lei_mu_data.category_list.map((itemCatrgory) => itemCatrgory.name)
      newRow.name = shang_pin_ming_cheng
      newRow.spec = gui_ge_shi_li
      newRow.unit = this.$tool.getDanWei(dan_wei)
      newRow.goods_price = dan_jia
      if (!this.selfData.counts) {
        newRow.counts = zong_shu_liang
        newRow.goods_amount = zong_jin_e
      } else {
        // 如果汇总有数量，则全部按照汇总数量更新
        newRow.counts = this.selfData.counts
        newRow.goods_amount = this.$XEUtils.multiply(newRow.goods_price, newRow.counts)
      }

      // 汇总更新字段
      this.selfData.name = this.selfData.name || newRow.name
      this.selfData.spec = newRow.spec
      this.selfData.unit = newRow.unit
      this.selfData.counts = this.selfData.counts || newRow.counts

      Object.keys(newRow).forEach((key) => {
        this.selfData.table_data_1[0][key] = this.$util.deepCopy(newRow[key])
      })
      list.forEach((itemSt) => {
        this.selfData[itemSt].forEach((itemNd) => {
          // 零件更新部分字段
          if (itemSt === 'table_data_2') {
            itemNd.name = newRow.name
            itemNd.goods_price = newRow.goods_price
            itemNd.goods_amount = newRow.goods_amount
          }
          if (itemSt === 'table_data_4') {
            // 其他费用有值，则不更新
            itemNd.spec = itemNd.spec || newRow.spec
            itemNd.unit = itemNd.unit || newRow.unit
            itemNd.counts = itemNd.counts || newRow.counts
          } else {
            // 其他更新部分字段
            itemNd.spec = newRow.spec
            itemNd.unit = newRow.unit
            itemNd.counts = newRow.counts
          }
        })
      })
    },
    // 新增商品
    doShangPin(row) {
      this.muBanId = row.id
      this.isShowPopupDoShangPin = true
    },
    // 增改商品成功
    doShangPinSuccess(data) {
      let row = this.$util.deepCopy(data)
      let wu_liao_type = this.lei_mu_lei_xing === '原料' ? '自建商品' : '其他商品'
      row.wu_liao_type = wu_liao_type
      this.chooseShangPinSuccess(row)
    },
    // 选择模板
    chooseMuBan(index) {
      this.activeTableData3Index = index
      this.isShowPopupChooseMuBan = true
    },
    // 项-选择模板成功
    chooseMubanSuccess(row) {
      let index = this.activeTableData3Index
      this.selfData.table_data_3[index].bind_id = row.id
      this.selfData.table_data_3[index].name = row.mu_ban_ming_cheng
      this.selfData.table_data_3[index].list_fenl_lei_ids = row.lei_mu_data.category_list.map(
        (itemCatrgory) => itemCatrgory.id
      )
      this.selfData.table_data_3[index].list_fenl_lei_str = row.lei_mu_data.category_list.map(
        (itemCatrgory) => itemCatrgory.name
      )
    },
    // 选择工艺模板（下拉列表）
    doGongYiShangPin({ item, rowIndex }) {
      let index = rowIndex !== null ? rowIndex : 0
      this.selfData.table_data_3[index].bind_id = item.id
      this.selfData.table_data_3[index].name = item.mu_ban_ming_cheng
      if (item.lei_mu_data && item.lei_mu_data.category_list) {
        this.selfData.table_data_3[index].list_fenl_lei_ids = item.lei_mu_data.category_list.map(
          (itemCatrgory) => itemCatrgory.id
        )
        this.selfData.table_data_3[index].list_fenl_lei_str = item.lei_mu_data.category_list.map(
          (itemCatrgory) => itemCatrgory.name
        )
      }
    },
    // 删除零件
    deleteLingJian() {
      let row = this.$util.deepCopy(this.selfData.table_data_1[0])
      let list = ['table_data_3', 'table_data_4']
      this.selfData.spec = row.spec
      this.selfData.unit = row.unit
      this.selfData.counts = row.counts
      list.forEach((itemSt) => {
        this.selfData[itemSt].forEach((itemNd) => {
          if (itemSt === 'table_data_4') {
            itemNd.spec = itemNd.spec || row.spec
            itemNd.unit = itemNd.unit || row.unit
            itemNd.counts = itemNd.counts || row.counts
          } else {
            itemNd.spec = row.spec
            itemNd.unit = row.unit
            itemNd.counts = row.counts
          }
        })
      })
    },
    // 更新-字段
    fieldUpdate(data) {
      let { idx, key, val } = data
      let list = []
      // 更新成本核算报告时
      if (idx === 0) {
        if (this.isOpenLingJian) {
          list = ['table_data_2', 'table_data_3', 'table_data_4']
        } else {
          list = ['table_data_1', 'table_data_3', 'table_data_4']
        }
      }
      if (idx === 1) {
        // 原料字段变更：启用零件时，spec/unit 变化仅更新汇总不写入下游
        if (this.isOpenLingJian && ['spec', 'unit'].includes(key)) {
          this.selfData[key] = val
          return
        }
        // 手动模式下：原料数量不级联覆盖零件数量，零件数量各自手填
        if (this.isManualVerify && key === 'counts') {
          list = ['table_data_3', 'table_data_4']
          list.forEach((itemSt) => {
            this.selfData[itemSt].forEach((itemNd) => {
              if (itemSt === 'table_data_4') {
                itemNd[key] = itemNd[key] || val
              } else {
                itemNd[key] = val
              }
            })
          })
          this.selfData[key] = val
          return
        }
        list = ['table_data_2', 'table_data_3', 'table_data_4']
      }
      if (idx === 2) list = ['table_data_3', 'table_data_4']
      list.forEach((itemSt) => {
        this.selfData[itemSt].forEach((itemNd) => {
          if (itemSt === 'table_data_4') {
            itemNd[key] = itemNd[key] || val
          } else {
            itemNd[key] = val
          }
        })
      })
      this.selfData[key] = val
    },
    // 原材料计算完成-级联更新下游
    onRawMaterialCalcComplete(data) {
      let { goods_price, counts, spec, unit } = data
      // 更新汇总数据
      this.selfData.spec = spec
      this.selfData.unit = unit
      this.selfData.counts = counts

      if (this.isOpenLingJian && !this.isManualVerify) {
        // 启用零件时：更新零件的 goods_price 和 goods_amount
        this.selfData.table_data_2.forEach((item) => {
          let singleCount = this.$tool.getSinglePartCount(spec, item.spec)
          item.counts = this.$XEUtils.multiply(counts, singleCount)
          item.goods_price = this.$XEUtils.round(this.$XEUtils.divide(goods_price, singleCount), 4)
          item.goods_amount = this.$XEUtils.multiply(Number(item.goods_price), Number(item.counts))
        })
        // 工艺和其他费用从零件继续级联
        let lingJianRow = this.selfData.table_data_2[0]
        if (lingJianRow) {
          this.cascadeToDownstream(lingJianRow)
        }
      } else {
        // 未启用零件（或零件规格含括号不互算）时：直接级联到工艺和其他费用
        this.cascadeToDownstream({ spec, unit, counts })
      }
    },
    // 级联更新到工艺和其他费用表
    cascadeToDownstream(sourceRow) {
      let { spec, unit, counts } = sourceRow
      // 更新工艺表
      this.selfData.table_data_3.forEach((item) => {
        item.spec = spec
        item.unit = unit
        item.counts = counts
        item.goods_amount = this.$XEUtils.multiply(Number(item.goods_price), Number(counts))
      })
      // 更新其他费用表（仅在字段为空时更新，保留用户自定义值）
      this.selfData.table_data_4.forEach((item) => {
        item.spec = item.spec || spec
        item.unit = item.unit || unit
        item.counts = item.counts || counts
        item.goods_amount = this.$XEUtils.multiply(Number(item.goods_price), Number(item.counts))
      })
    },
    // 原材料单价手动修改-更新零件单价和金额（尾料分摊：原材料总成本 = 零件总成本）
    onRawPriceChange(data) {
      if (this.isCascadingPrice || this.isManualVerify) return
      this.isCascadingPrice = true
      let { goods_price, counts } = data
      let rawAmount = this.$XEUtils.multiply(Number(goods_price), Number(counts))
      // 不回写 table_data_1（子组件已处理），只更新下游零件表
      if (this.isOpenLingJian) {
        let totalPartsCounts = 0
        this.selfData.table_data_2.forEach((item) => {
          totalPartsCounts = this.$XEUtils.add(totalPartsCounts, Number(item.counts))
        })
        if (totalPartsCounts > 0) {
          this.selfData.table_data_2.forEach((item) => {
            item.goods_price = this.$XEUtils.round(this.$XEUtils.divide(rawAmount, totalPartsCounts), 4)
            item.goods_amount = this.$XEUtils.multiply(Number(item.goods_price), Number(item.counts))
          })
        }
      }
      this.$nextTick(() => {
        this.isCascadingPrice = false
      })
    },
    // 零件单价手动修改-反向更新原材料单价和金额（尾料分摊：零件总成本 = 原材料总成本）
    onPartPriceChange(data) {
      if (this.isCascadingPrice || this.isManualVerify) return
      this.isCascadingPrice = true
      // 使用子组件直接传过来的总金额（避免读取尚未同步的父数据）
      let totalPartsAmount = data.totalPartsAmount
      // 反向更新原材料：原材料总成本 = 零件总成本（含尾料分摊）
      let rawCounts = Number(this.selfData.table_data_1[0].counts)
      if (rawCounts > 0) {
        let rawPrice = this.$XEUtils.round(this.$XEUtils.divide(totalPartsAmount, rawCounts), 4)
        this.selfData.table_data_1[0].goods_price = rawPrice
        this.selfData.table_data_1[0].goods_amount = this.$XEUtils.multiply(rawPrice, rawCounts)
      }
      this.$nextTick(() => {
        this.isCascadingPrice = false
      })
    },

    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.popupCancel()
      this.selfData.table_data_3.forEach((item, index) => {
        item.seq = `工序${index + 1}` // 设置工序
      })
      this.$emit('update:data', this.selfData)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .popup-scroll {
    overflow-y: auto;
    .scroll-bar();
  }
  /deep/ .vxe-grid .vxe-grid--table-wrapper {
    overflow: visible !important;
  }
  /deep/ .vxe-table--body-wrapper {
    overflow: visible !important;
  }
}
</style>
